import React from 'react';
import styled from 'styled-components';

import { ShimmerOverlay } from 'components/Globals';

const QuestionContainer = styled.div`
  display: flex;
`;

const QuestionNumber = styled.div`
  background-color: ${({ theme }) => theme.color.grey[4]};
  border-radius: 8px;
  display: inline-block;
  height: 60px;
  position: relative;
  width: 96px;
`;

const QuestionTitle = styled.div`
  background-color: ${({ theme }) => theme.color.grey[5]};
  border-radius: 4px;
  border: 0;
  height: 32px;
  margin-left: 32px;
  position: relative;
  width: 600px;
`;

const Codesnippet = styled.div`
  background-color: ${({ theme }) => theme.color.blue[0]};
  background-size: 600px 100%;
  border-radius: 4px;
  border: 0;
  height: 96px;
  margin-left: 32px;
  margin-top: 24px;
  position: relative;
  width: 408px;
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  margin-left: 16px;
  align-items: flex-start;
`;

const Option = styled.div`
  background-color: ${({ theme, blue }) => (blue ? theme.color.blue[1] : theme.color.grey[4])};
  border-radius: 4px;
  height: 32px;
  margin: 20px;
  margin-left: 0;
  width: 524px;
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 540px;
  opacity: 0.4;
  position: relative;
  width: 100%;
`;

const Skeleton = () => {
  return (
    <CardContainer>
      <ShimmerOverlay>
        <QuestionContainer>
          <QuestionNumber />

          <div>
            <QuestionTitle />
            <Codesnippet />
          </div>
        </QuestionContainer>

        <OptionsContainer>
          <Option />
          <Option />
          <Option />
          <Option />
          <Option />
        </OptionsContainer>
      </ShimmerOverlay>
    </CardContainer>
  );
};

export default Skeleton;
